import React, { useRef } from "react";
import { SimpleGrid, Text, Box } from "@chakra-ui/react"
import Transition from "../../components/Layout/Transition";
import { useStaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Background from "../../components/Layout/Background";
import a from "../../images/background/86.svg"
import b from "../../images/background/4.svg"
import c from "../../images/background/19.svg"


export default function About() {
    const ref = useRef()
    const data = useStaticQuery(
        graphql`
        query {
            allContentfulAbout(sort: {fields: id}) {
              totalCount
              edges {
                node {
                    title
                    description {
                        raw
                    }
                }
              }
            }
          } 
        `
    )
    

    return (
        <>
            <Box position="relative" d="flex" pt="10vh" pb="10vh" alignItems="center">
                <Background src={a} left="-5vw" top={0} width='8vw' />
                <Background src={b} right="-25vw" top='12vw' width='18vw'/>
                <Background src={c} left="-22vw" top='35vw' width='16vw' />
                <SimpleGrid
                    rows={2}
                    columns={1}
                    alignItems="stretch"
                    gap={10}
                >
                    {data.allContentfulAbout.edges.map((edge, i) => {
                        return (
                            <Transition>
                                <Box key={i} ref={ref} bgColor="white" p={[8, 10, 10, 10]} borderRadius={20}>
                                    <Text fontSize={[28, 34, 40, 42]} fontWeight={600} mb={3}>{edge.node.title}</Text>
                                    <Text fontSize={[16, 16, 18, 18]} fontWeight={400}>
                                        {documentToReactComponents(JSON.parse(edge.node.description.raw))}
                                    </Text>
                                </Box>
                            </Transition>
                        )
                    })}
                </SimpleGrid>
            </Box>
        </>
    )
}